<template>
  <div style="margin: 10px">
    <div>
      <div style="margin-bottom: 5px; margin-top: 5px">
        <el-button @click="excelPost()">打印</el-button>
      </div>
    </div>
    <div class="cdj_div" style="margin-top: 20px">系统欠费检、抽查记录表</div>
    <el-descriptions
      :column="2"
      border
      size="mini"
      :labelStyle="{ width: '123px', color: 'black' }"
      :contentStyle="{ width: '42%' }"
    >
      <el-descriptions-item label="计费周期">
        <el-date-picker
          size="mini"
          v-model="startDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="开始时间"
        ></el-date-picker>
        <span class="cdj_text_data">至</span>
        <el-date-picker
          size="mini"
          v-model="endDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="结束时间"
        ></el-date-picker>
      </el-descriptions-item>
      <el-descriptions-item label="房产">
        <div style="display: flex">
          <div
            @click="houses"
            v-if="data.house"
            style="cursor: pointer; color: red"
            :class="data.house.length > 30 ? 'dade-text' : ''"
          >
            {{ data.house }}
          </div>
          <div
            @click="houses_del"
            v-if="data.house"
            style="cursor: pointer; margin-left: 10px"
          >
            取消选择
          </div>
          <div @click="houses" v-else style="cursor: pointer">选择房产...</div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="应收日期">
        <el-date-picker
          size="mini"
          v-model="shouldStartDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="开始时间"
        ></el-date-picker>
        <span class="cdj_text_data">至</span>
        <el-date-picker
          size="mini"
          v-model="shouldEndDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="结束时间"
        ></el-date-picker>
      </el-descriptions-item>

      <el-descriptions-item label="费用类型">
        <div style="display: flex">
          <div
            @click="chargeitems"
            v-if="data.chargeitemIDName"
            style="cursor: pointer; color: red"
            :class="data.chargeitemIDName.length > 30 ? 'dade-text' : ''"
          >
            {{ data.chargeitemIDName }}
          </div>
          <div
            @click="chargeitems_del"
            v-if="data.chargeitemIDName"
            style="cursor: pointer; margin-left: 10px"
          >
            取消选择
          </div>
          <div @click="chargeitems" v-else style="cursor: pointer">
            选择收费项目...
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="已收日期">
        <el-date-picker
          size="mini"
          v-model="operatorStartDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="开始时间"
        ></el-date-picker>
        <span class="cdj_text_data">至</span>
        <el-date-picker
          size="mini"
          v-model="operatorEndDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="结束时间"
        ></el-date-picker>
      </el-descriptions-item>

      <el-descriptions-item label="收费标准">
        <div style="display: flex">
          <div
            @click="charge"
            v-if="data.chargeName"
            style="cursor: pointer; color: red"
            :class="data.chargeName.length > 30 ? 'dade-text' : ''"
          >
            {{ data.chargeName }}
          </div>
          <div
            @click="charge_del"
            v-if="data.chargeName"
            style="cursor: pointer; margin-left: 10px"
          >
            取消选择
          </div>
          <div @click="charge" v-else style="cursor: pointer">
            选择收费标准...
          </div>
        </div>
      </el-descriptions-item>



    </el-descriptions>
    <!-- 房产 -->
    <house ref="house"></house>
    <!-- 收费项目 -->
    <Chargeitem ref="chargeitem" @chargeitemAll="chargeitemAll"></Chargeitem>
    <!-- 收费标准 -->
    <Charge ref="charges" @chargesAll="chargesAll"></Charge>

    <excel-task
      ref="ExcelTask"
      :excelTask="excelTask"
      :excelTaskId="excelTaskId"
      @close="closeExcelTask"
    />
  </div>
</template>

<script>
import ExcelTask from "@/components/common/excelTask";
// import House from "@/components/Admin/Forms/common/SelectProjectHouse";
// import Chargeitem from "@/components/Admin/Forms/common/Chargeitem";
// import Charge from "@/components/Admin/Forms/common/Charge";
export default {
  name: "FormsOweCheck",
  components: {
    "room-user": () => import("../Common/room-user.vue"),
    house: () => import("./common/SelectProjectHouse.vue"),
    Chargeitem: () => import("./common/Chargeitem.vue"),
    Charge: () => import("./common/Charge.vue"),
    RoomStatus: () => import("./common/RoomStatus.vue"),
    ExcelTask,
  },
  data() {
    return {
      data: {
        house_id: "",
        startDate: "",
        endDate: "",
        shouldStartDate: "",
        shouldEndDate: "",
        operatorStartDate: "",
        operatorEndDate: "",
        chargeitemID: "",
        chargeitemIDName: "",
        charge_id: "",
        chargeName: "",
        house: "",
      },
      startDate: "",
      endDate: "",
      shouldStartDate: "",
      shouldEndDate: "",
      operatorStartDate: "",
      operatorEndDate: "",
      charge_id: "",
      chargeName: "",
      excelTaskId: "",
      excelTask: false,
      modal1: false,
      house_1: "",
      loading: false,
    };
  },
  methods: {
    excelPost() {
      if (this.startDate == "") {
        this.$message.error("请选择计费周期开始时间");
        return;
      }
      if (this.endDate == "") {
        this.$message.error("请选择计费周期结束时间");
        return;
      }
      if (this.data.house_id == "") {
        this.$Message.error("房产不能为空");
        return false;
      }
      this.data.targetController = "OweCheckController";
      this.data.taskName = "系统欠费检、抽查记录表";
      this.data.targetFunction = "excel1";
      this.data.startDate = this.startDate / 1000;
      this.data.endDate = this.endDate / 1000;
      this.data.shouldStartDate = this.shouldStartDate / 1000;
      this.data.shouldEndDate = this.shouldEndDate / 1000;
      this.data.operatorStartDate = this.operatorStartDate / 1000;
      this.data.operatorEndDate = this.operatorEndDate / 1000;
      ERP.showLoading();
      this.$myhttp
        .post("admin/ExcelTask/addTask", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          this.$store.commit("excelTaskAdd");
          this.$Message.success("创建导出任务成功");
          var data = backdata.data.data;
          this.excelTaskId = data.excelTaskId;
          this.openExcelTask();
        })
        .catch(function (error) {
          this.$Message.error("出错了");
          ERP.hideLoading();
        });
    },
    //选择房产
    houses() {
      let _this = this;
      this.$refs.house.show([], function (data) {
        //整理项目和房产ID
        _this.$myhttp
          .post("admin/common/house_tree_id", data, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            _this.data.house_id = backdata.data.house_ids;
            _this.data.house = backdata.data.ancestor_name;
            _this.data.chargeitemID = "";
            _this.data.chargeitemIDName = "";
            _this.data.charge_id = "";
            _this.data.chargeName = "";
          })
          .catch(function (error) {
            _this.$Message.error("选择房产失败");
          });
      });
    },
    houses_del() {
      this.data.house_id = "";
      this.data.house = "";
    },
    //选择收费项目
    chargeitems() {
      this.$refs.chargeitem.getInvo(this.data);
    },
    chargeitems_del() {
      this.data.chargeitemID = "";
      this.data.chargeitemIDName = "";
    },
    chargeitemAll() {
      let data = this.$refs.chargeitem.getReturn();
      this.data.chargeitemID = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      this.data.chargeitemIDName = data
        .map((ret) => {
          return ret.label;
        })
        .join(",");
      this.data.charge_id = "";
      this.data.chargeName = "";
    },
    //选择收费标准
    charge() {
      console.log('$refs', this.$refs)
      this.$refs.charges.getInvo(this.data);
    },
    charge_del() {
      this.data.charge_id = "";
      this.data.chargeName = "";
    },
    chargesAll() {
      let data = this.$refs.charges.getReturn();
      this.data.charge_id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      this.data.chargeName = data
        .map((ret) => {
          return ret.label;
        })
        .join(",");
    },
    openExcelTask() {
      this.$store.commit("excelTaskClear");
      this.excelTask = true;
      this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
  },
};
</script>

<style>
@import "../../../assets/css/table.css";
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}
.dade-text {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/oweCheck.vue